<template>
  <div>
    <b-container fluid class="p-0 m-0">
      <b-row>
        <b-col class="document-column" cols="12" lg="2" v-for="(doc, index) in documents" :key="index">
          <b-row class="document-row-title">
            <b-col cols="12" class="overflow-hidden">
              {{ getDocnameByType(doc) }}
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-link
                :href="doc.file"
                class="font-italic font-weight-bold"
                target="_blank"
              >
                {{ $t("document_card_list.see_document") }}
              </b-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
const translation_key_by_file_type = {
  22: "document_card_list.file_importation_recipe_label",
  23: "document_card_list.file_importation_treatment_label",
  24: "document_card_list.file_importation_identification_label",
  25: "document_card_list.file_importation_doctor_cv_label",
  26: "document_card_list.file_payment_instructions",
};
const hide_file_title = {
  26: true,
};

export default {
  name: "v-document-card-list",
  components: {},
  props: {
    documents: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  computed: {},
  fallbackI18n: {
    messages: {
      und: {
        document_card_list: {
          file_importation_recipe_label: "Original recipe",
          file_importation_treatment_label: "Treatment summary",
          file_importation_identification_label: "Identification document",
          file_importation_doctor_cv_label: "Doctor's CV",
          file_payment_instructions: "Payment instructions",
          unknown_file_type_label: "File",
          see_document: "Review document",
        },
      },
    },
  },
  methods: {
    getDocnameByType(doc) {
      if (!hide_file_title[doc.file_type] && doc.file_title) {
        return doc.file_title;
      }
      if (translation_key_by_file_type[String(doc.file_type)]) {
        return this.$t(translation_key_by_file_type[String(doc.file_type)]);
      }
      return this.$t("document_card_list.unknown_file_type_label");
    },
  },
};
</script>

<style lang="scss" scoped>
.document-column {
  min-height: 8rem;
}
.document-row-title {
  min-height: 4rem;
}
</style>
